import { useEffect, useState } from 'react';
import { subscribeAgentStatus, type AgentStatusRecord } from '../lib/agentPresence';

export default function AgentPresenceDebug() {
  const [statuses, setStatuses] = useState<AgentStatusRecord[]>([]);

  useEffect(() => subscribeAgentStatus(setStatuses), []);

  return (
    <div className="space-y-2">
      <div className="border-t pt-2 font-semibold text-gray-700">Firebase Agent Presence</div>
      {statuses.length === 0 && <div className="text-gray-500">No agent statuses yet.</div>}
      {statuses.map((agent) => (
        <div key={agent.email} className="rounded border border-gray-100 bg-gray-50 p-2">
          <div className="flex items-center justify-between gap-2">
            <span className="truncate font-medium">{agent.name || agent.email}</span>
            <span
              className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${
                agent.status === 'available'
                  ? 'bg-green-100 text-green-700'
                  : agent.status === 'busy'
                    ? 'bg-yellow-100 text-yellow-700'
                    : 'bg-gray-200 text-gray-600'
              }`}
            >
              {agent.status}
            </span>
          </div>
          <div className="truncate text-gray-500">{agent.email}</div>
          <div className="truncate text-gray-500">Call: {agent.currentCallUuid || '-'}</div>
          <div className="text-gray-500">
            Last seen: {agent.lastSeen ? new Date(agent.lastSeen).toLocaleTimeString() : '-'}
          </div>
        </div>
      ))}
    </div>
  );
}
